import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const SubTextDivider = ({ classes }) => {
  return (
    <Typography display='inline'>
      <span className={classes.root}>|</span>
    </Typography>
  );
};

const styles = theme => ({
  root: {
    fontWeight: 'normal',
    color: 'darkgray',
    fontSize: '1.5rem',
    paddingLeft: '5px',
    paddingRight: '5px'
  }
});

export default withStyles(styles)(SubTextDivider);
